<template>
    <v-dialog
        v-model = "abrir"
        @keydown.esc = "cerrar"
        max-width="750px" 
        scrollable
        persistent>
        
        <v-card>
            <v-card-title>
                <span class="headline">{{ titulo }}</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <v-form ref="form" v-model = "formaValida">
                    <v-layout wrap>
                        <v-flex xs6 sm6 md6 v-if = "!nuevo">
                            <span class="body-1">¿Contacto activo?</span>
                            <v-switch
                                v-model = "datos['estatus']"
                                :label = "etiqueta"
                            ></v-switch>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-select
                                ref = "tipo"
                                class = "body-1"
                                :items = "['Trabajadores', 'Mentores', 'Aliados', 'Tutores']"
                                v-model = "datos['tipo']"
                                label = "Seleccione tipo de persona"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field
                                ref="nombre"
                                class = "body-1"
                                v-model = "datos['nombre']"
                                label = "Nombre(s)"
                                required
                            />
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field
                                ref="paterno"
                                class = "body-1"
                                v-model = "datos['paterno']"
                                label = "Apellido Paterno"
                                required
                            />
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field
                                ref="nombre"
                                class = "body-1"
                                v-model = "datos['materno']"
                                label = "Apellido Paterno"
                                required
                            />
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field
                                ref=telefono
                                class = "body-1"
                                v-model = "datos['telefono']"
                                label = "Telefono"
                                :rules = "[reglas.requerido, reglas.numerocorrecto]"
                                @keypress = "onlyNumber"
                                maxlength = 10
                                :counter = "10"
                                required
                            />
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field
                                ref=ext
                                class = "body-1"
                                v-model = "datos['ext']"
                                label = "Ext."
                                :rules = "[reglas.numerocorrecto]"
                                @keypress = "onlyNumber"
                                maxlength = 4
                                :counter = "4"
                            />
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field
                                ref=celular
                                class = "body-1"
                                v-model = "datos['celular']"
                                label = "Celular"
                                :rules = "[reglas.numerocorrecto]"
                                @keypress = "onlyNumber"
                                maxlength = 10
                                :counter = "10"
                                required
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-textarea
                                ref="infoadicional"
                                class = "body-1"
                                v-model = "datos['infoadicional']"
                                label = "Informacion adicional"
                                required
                            />
                        </v-flex>
                    </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                color="blue darken-1"
                text
                @click="cerrar">Cancelar</v-btn>
                <v-btn
                color="blue darken-1"
                text
                :disabled = "activarBoton"
                @click = "guardar">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        datos: Object,
        abrir: Boolean,
        nuevo: Boolean,
        titulo: String
    },
    data() {
        return {
            formaValida: false,
            reglas: {
                requerido: (value) => !!value || 'Campo requerido',
                email: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo electrónico inválido.'
                },
                numerocorrecto: (value) => {
                    const patron = /^\d*\.?\d*$/
                    return patron.test(value) || 'EL formato del numero no es correcto'
                }
            },
        }
    },
    
    computed: {
        activarBoton(){
            if(!this.nuevo){
                return false;
            }else{
                return !this.formaValida;
            }
        },
        etiqueta(){
            if(this.datos['estatus'] == true){
                return "Si"
            }else{
                return "No"
            }
        }
    },
    
    methods: {  
        async guardar() {
            if (!this.nuevo) {
                console.log("guardando edicion");
                try{
                    await ServiceHandler.updateElement("personas", this.datos);
                    this.cerrar();
                    this.$emit('actualizarTabla');
                    alert("Se han guardado los cambios realizados");
                }catch(e){
                    alert("Hubo un error al guardar la información: " + e.message);
                }
            } else {
                try{
                    console.log("entrando a guardar...");
                    const temp = await ServiceHandler.getID("PE");
                    this.datos._id = "PE-" + (parseInt(temp.value.sequence_value)+1);
                    this.datos.activo = "Si"
                                        
                    await ServiceHandler.insertElement("personas", this.datos);
                    alert("Se ha guardado la nueva persona");
                    this.$emit('actualizarTabla'); 
                    this.cerrar();
                }catch(e){
                    alert("Hubo un error al intentar generar el nuevo registro: " + e.message);
                }
            }
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 45) { // 46 es el punto
                $event.preventDefault();
            }
        },
        cerrar() {
            //console.log("enviando señal de cierre");
            this.$refs.form.reset();
            this.$emit('cerrarVentana');
        },
    },
}
</script>